import { useCallback, useEffect, useState } from 'react';
import { friendlyErrorMapping } from '../../../utils';
import { useLoading } from '../../../context';

export const useVerifyEmailResult = ({ email, token }) => {
  const [isVerified, setIsVerified] = useState(false);
  const [loading, setLoading] = useState(true);
  const { showLoading, hideLoading } = useLoading();
  const [error, setError] = useState(null);

  const checkEmailVerification = useCallback(async () => {
    setLoading(true);
    showLoading();
    try {
      const response = await fetch('/api/user/verify-email', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email,
          token,
        }),
      });
      if (response.ok) {
        setIsVerified(true);
      } else {
        throw await response.json();
      }
    } catch (error) {
      const errorMessage =
        friendlyErrorMapping[error.code] ?? error.message ?? error;
      setError(errorMessage);
    } finally {
      setLoading(false);
      hideLoading();
    }
  }, [email, hideLoading, showLoading, token]);

  useEffect(() => {
    checkEmailVerification();
  }, [checkEmailVerification]);

  return { loading, isVerified, error };
};
